/* Local storage for wizard drafts (never persisted server-side) */

const KEY = "ariovis.roadmap.draft.v1";

export const draftStore = {
  save(state) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ ...state, savedAt: Date.now() }));
    } catch (_) { /* ignore */ }
  },
  load() {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (_) { return null; }
  },
  clear() {
    try { localStorage.removeItem(KEY); } catch (_) { /* ignore */ }
  },
};
